<template>
	<div class="clx-video">
		<titles :names="'comment'"></titles>
		<!-- 主体 -->
		<div class="clx-home-main">
			<div class="clx-home-main-background"></div>
			<!-- 详情 -->
			<div class="clx-home-main-content">
				<div class="clx-home-main-topvideobox" v-for="(item,index) in listtudata">
					<video :src="item.imgs"  :autoplay="false" ref="videoplayer1" :controls="true" :id="'video'+index"
						:poster="item.url"
						@play="handlePlay(index)"></video>
					<span>{{item.tit}}</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import titles from '../../components/pagetitle/title'
	export default {
		name: "lawyer-c",
		components: {
			titles
		},
		data() {
			return {
				keyword: '', //要搜索关键字
				videoModelShow: false, //视频弹窗隐藏
				videoplayer: '',
				imgsrc: '',
				listtudata: [{
						tit: '河北财政政策为稳增长保民生提供有力支撑',
						imgs: 'https://movie-tyc.obs.cn-north-4.myhuaweicloud.com/econ/video/z-1.mp4',
						url: require('../../assets/jjydt/zcdp/z- (1)_Moment.jpg')
					},
					{
						tit: '河北“加减”政策共发力 纾困减负中小科企',
						imgs: 'https://movie-tyc.obs.cn-north-4.myhuaweicloud.com/econ/video/z-2.mp4',
						url: require('../../assets/jjydt/zcdp/z- (2)_Moment.jpg')
					},
					{
						tit: '河北：政策"红利" 惠企稳岗扩就业',
						imgs: 'https://movie-tyc.obs.cn-north-4.myhuaweicloud.com/econ/video/z-3.mp4',
						url: require('../../assets/jjydt/zcdp/z- (3)_Moment.jpg')
					},
					{
						tit: '河北交通“六条措施”为经济发展开道护航',
						imgs: 'https://movie-tyc.obs.cn-north-4.myhuaweicloud.com/econ/video/z-4.mp4',
						url: require('../../assets/jjydt/zcdp/z- (4)_Moment.jpg')
					},
					{
						tit: '河北工程审批制度改革 项目跑出“加速度"',
						imgs: 'https://movie-tyc.obs.cn-north-4.myhuaweicloud.com/econ/video/z-5.mp4',
						url: require('../../assets/jjydt/zcdp/z- (5)_Moment.jpg')
					},
					{
						tit: '河北增值税留抵退税560多亿 力保市场主体稳定发展',
						imgs: 'https://movie-tyc.obs.cn-north-4.myhuaweicloud.com/econ/video/z-6.mp4',
						url: require('../../assets/jjydt/zcdp/z- (6)_Moment.jpg')
					}
				]
			}
		},

		methods: {
			handlePlay(ins) {
				console.log(name)
				this.listtudata.map((item,index)=>{
					if(ins==index){
						let video=document.getElementById('video'+ins)
						video.play()
					}else{
						let video=document.getElementById('video'+index)
						video.pause()

					}
				})
			},
			createPreImg(event) { // event js原生事件
				const videoEle = event.target; // 当前video dom节点
				videoEle.currentTime = 0; // 设置视频开始播放时间（因为有些手机第一帧显示黑屏，所以这里选取视频的第一秒作为封面）
				videoEle.addEventListener('canplay', function() { // 监听video的canplay事件
					// 创建canvas元素 并设置canvas大小等于video节点的大小
					const canvas = document.createElement('canvas');
					videoEle.oncanplay = () => {
						// const scale = 0.8; // 压缩系数
						canvas.width = videoEle.videoWidth;
						canvas.height = videoEle.videoHeight;
						// canvas画图
						canvas.getContext('2d').drawImage(videoEle, 0, 0, canvas.width, canvas.height);
						// 把canvas转成base64编码格式
						const imgSrc = canvas.toDataURL('image/png');
						videoEle.poster = imgSrc
					};
				});
			},
			// 查询
			iSearch() {
				if (!this.keyword) {
					this.$clxTools.iMessage(this, 'e', '请输入内容后查询', 4)
					return
				}
				this.$router.push({
					name: 'result',
					params: {
						keyword: this.keyword
					}
				})
			},
		},
		created() {
			let keyword = this.$route.params.keyword
		},
		mounted() {
			if(window.screen.width>750){
				console.log("",window.screen.width)
				const html = document.querySelector('html');
				const width =window.screen.width
				html.style.fontSize = width/13 +'px'
			}
		},
	};
</script>

<style lang="less">
	.clx-video {
		width: 7.5rem;
		padding: 0 0.24rem;
		margin: 0 auto;
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: center;
		-webkit-user-select: none;
		-webkit-touch-callout: none;
		background: url(../../assets/clx-images/big-bg2.jpg) no-repeat center 0px;
		background-size: cover;

		// 主体
		.clx-home-main {
			// height: ~"calc(100vh -6rem)";
			// min-height: 5rem;
			height: 58%;
			position: relative;
			border-radius: 0.1rem;
			width: 100%;

			.clx-home-main-background {
				top: 0;
				position: absolute;
				width: 100%;
				height: 100%;
				background-color: #fff;
				border-radius: 0.2rem;
				border: 0.01rem solid #FFC35D;
				opacity: 0.4;
				z-index: 1;
			}

			// 内容
			.clx-home-main-content {
				// padding: 0.32rem 0.3rem;
				height: 100%;
				z-index: 2;
				position: absolute;
				overflow-x: hidden;
				overflow-y: auto;

				.clx-home-main-topvideobox {
					display: flex;
					flex-direction: column;
					justify-content: space-around;
					align-items: center;
					padding: 0.3rem 0;
					margin: 0 0.3rem;
					// border-bottom: 0.02rem solid #D7D7D7;

					span {
						font-size: 0.34rem;
						color: #000;
						font-weight: bold;
					}

					video {
						max-width: 100%;
						border-radius: 0.1rem;
						overflow: hidden;
						margin-bottom: 0.3rem;
					}
				}


				// 滚动条
				&::-webkit-scrollbar-track-piece {
					background-color: rgba(0, 0, 0, 0);
					border-left: 1px solid rgba(0, 0, 0, 0);
				}

				&::-webkit-scrollbar {
					width: 2px;
					height: 13px;
					-webkit-border-radius: 5px;
					-moz-border-radius: 5px;
					border-radius: 5px;
				}

				&::-webkit-scrollbar-thumb {
					background-color: rgba(0, 0, 0, 0.2);
					background-clip: padding-box;
					-webkit-border-radius: 5px;
					-moz-border-radius: 5px;
					border-radius: 5px;
					min-height: 28px;
				}

				&::-webkit-scrollbar-thumb:hover {
					background-color: rgba(0, 0, 0, 0.2);
					-webkit-border-radius: 5px;
					-moz-border-radius: 5px;
					border-radius: 5px;
				}
			}
		}
	}
</style>
